<template>
  <div class="pa-4 pa-md-5">
    <!-- Botón Volver -->
    <v-btn @click="$router.back()" class="back-btn mb-3">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>

    <!-- Card de Selección de Rol y Leyenda de Permisos -->
    <v-card class="rounded-lg elevation-3 overflow-hidden mb-4">
      <v-toolbar height="54" color="secondary" dark flat class="px-3 px-md-4">
        <v-icon left>mdi-shield-key-outline</v-icon>
        <span class="text-h6 font-weight-medium">
          Configuración de Permisos por Rol
        </span>
        <v-chip
          v-if="selectedRoleName"
          small
          color="white"
          text-color="secondary"
          class="font-weight-bold ml-3 px-3 elevation-1"
          style="font-size: 0.9rem; height: 28px"
        >
          <v-icon left size="16" color="secondary">mdi-shield-account</v-icon>
          Rol Activo: {{ selectedRoleName }}
        </v-chip>
      </v-toolbar>

      <v-card-text class="pa-4 pa-md-5">
        <v-row align="center" dense>
          <!-- Selector de Rol -->
          <v-col cols="12" md="6" lg="5">
            <label class="text-caption font-weight-bold text--secondary mb-1 d-block">
              SELECCIONAR ROL A CONFIGURAR:
            </label>
            <v-autocomplete
              v-model="selected"
              @change="filtroRoles()"
              :items="ItemsSelect"
              item-value="id"
              item-text="name"
              label="Rol de Usuario"
              placeholder="Seleccionar rol..."
              outlined
              dense
              hide-details
              prepend-inner-icon="mdi-shield-account-outline"
              class="rounded-lg role-select"
            ></v-autocomplete>
          </v-col>

          <!-- Leyenda de Permisos y Ayuda Visual -->
          <v-col cols="12" md="6" lg="7">
            <div class="legend-card rounded-lg pa-3 ml-md-3">
              <div class="d-flex align-center flex-wrap gap-3">
                <div class="d-flex align-center mr-4">
                  <v-icon color="primary" class="mr-1" size="22">mdi-checkbox-marked</v-icon>
                  <span class="text-caption font-weight-bold text--primary">Permiso asignado</span>
                </div>
                <div class="d-flex align-center mr-4">
                  <v-icon color="grey lighten-1" class="mr-1" size="22">mdi-checkbox-blank-outline</v-icon>
                  <span class="text-caption font-weight-medium text--secondary">Permiso sin asignar</span>
                </div>
                <div class="d-flex align-center">
                  <span class="text--disabled text-body-2 font-weight-bold mr-1">—</span>
                  <span class="text-caption text--secondary">No aplicable al módulo</span>
                </div>
              </div>
              <div class="mt-2 text-caption text--secondary d-flex align-center">
                <v-icon x-small color="info" class="mr-1">mdi-information-outline</v-icon>
                <span>Haz clic en las casillas de la tabla para habilitar o revocar permisos en tiempo real.</span>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Tabla Principal de Matriz de Permisos -->
    <v-col cols="12" class="pa-0">
      <tabla
        Titulo="Matriz de Permisos por Rol"
        :menuData="Items"
        :permisosxroles="Permisosxroles"
        :headers="headers"
        :actionHeadersTable="actionHeadersTable"
        :actionHeaders="actionHeaders"
        :subHeaders="subHeaders"
        :subSubHeaders="subSubHeaders"
        :Excel="false"
        :Crear="false"
        :Loading="Loading"
        :filtroRoles="filtroRoles"
        :selected="selected"
        :selectedRoleName="selectedRoleName"
      />
    </v-col>
  </div>
</template>

<script>
import tabla from "@/components/permisos/tabla.vue";
import { axios2 as axios } from "@/interceptor/useApi";
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "Permisos",
  components: {
    tabla
  },
  created() {
    const data = {
      menu: 1,
      submenu: 1
    };

    this.getacciones();
    this.verRoles();
    this.CargarMenu(data);
    this.cargarPermisos()
      .then(() => {
        this.cargarPermisosxroles(this.selected || 1);
      })
      .catch(error => {
        console.error("Error al cargar permisos:", error);
      });
  },
  data() {
    return {
      selected: 1,
      actionHeaders: [
        { id: 1, label: "Visualizar" },
        { id: 2, label: "Agregar" },
        { id: 3, label: "Editar" },
        { id: 4, label: "Eliminar" }
      ],
      headers: [{ text: "Módulo", value: "menu" }],
      subHeaders: [{ text: "Submódulo", value: "description" }],
      subSubHeaders: [{ text: "Sub-submódulo", value: "description" }],
      actionHeadersTable: []
    };
  },
  computed: {
    ...mapGetters("permisos", ["Items", "ItemsSelect", "Permisosxroles"]),
    ...mapState("permisos", ["Loading"]),
    selectedRoleName() {
      if (!this.ItemsSelect || !this.selected) return "";
      const rol = this.ItemsSelect.find(r => r.id === this.selected);
      return rol ? rol.name : "";
    }
  },
  methods: {
    ...mapActions("permisos", ["cargarPermisos", "verRoles", "cargarPermisosxroles"]),
    ...mapActions("nav", ["CargarMenu"]),

    filtroRoles() {
      this.cargarPermisosxroles(this.selected);
    },

    getacciones() {
      try {
        const url = "getacciones";
        let datos = {};
        axios
          .post(url, datos)
          .then(response => {
            this.actionHeaders = response.data.success.resultado;
            this.actionHeadersTable = [];
            this.actionHeadersTable.push({
              text: "MÓDULO / SECCIÓN",
              value: "MÓDULO",
              sortable: false,
              align: "left",
              width: "320px"
            });
            this.actionHeadersTable.push({
              text: "TIPO MENÚ",
              value: "MENU",
              sortable: false,
              align: "center",
              width: "130px"
            });
            for (let i = 0; i < this.actionHeaders.length; i++) {
              const text = this.actionHeaders[i].name;
              const value = this.actionHeaders[i].id;
              this.actionHeadersTable.push({
                text: text.toUpperCase(),
                value: value,
                sortable: false,
                align: "center",
                width: "110px"
              });
            }
          })
          .catch(error => {
            console.error("Error al obtener acciones:", error);
          });
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.legend-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.gap-3 {
  gap: 12px;
}
</style>
